import React,{useState} from 'react'
import GameRoutes from '../../route/gameroutes/GameRoutes'
import SearchBar from '../../route/searchbar/SearchBar'
import Token from '../../component/token/Token'
import './ValorPage.scss'
import ceklis from '../../assets/ceklis.png'
import valor from '../../assets/valorant.png'
import Terms from '../../component/termsmodal/Terms'
import Activation from '../../component/activation/Activation'


const ValorPage = () => {

    const [show,setShow] = useState(false)
    const [show2,setShow2] = useState(false)
    const [show3,setShow3] = useState(false)
    const [show4,setShow4] = useState(false)

    const [showAct,setShowAct] = useState(false)


    const close = () => {
        setShow(false)
        setShow2(false)
        setShow3(false)
        setShow4(false)
        setShowAct(false)
    }
    return (
        <>
            <div className="valor__white">
                <div className="valor__container">
                    <SearchBar/>
                    <GameRoutes/>
                    <div className="valor__header">
                        <div className="valor__text">
                            <p>Valorant</p>
                        </div>
                        <div className="valor__activated" onClick={() => setShowAct(true)}>
                            <img src={ceklis} alt="ceklis"/>
                            <p>Activated</p>
                        </div>
                    </div>
                    <Token onClick={() => setShow(true)} onClick2={() => setShow2(true)} onClick3={() => setShow3(true)} onClick4={() => setShow4(true)}/>
                        {show && <Terms bgCover="valor--modal" header="SOLO LEAGUE" onClose={close} imagelogo={valor}/>}
                        {show2 && <Terms bgCover="valor--modal" header="SOLO Challange" onClose={close} imagelogo={valor}/>}
                        {show3 && <Terms bgCover="valor--modal" header="TEAM Round of 8" onClose={close} imagelogo={valor}/>}
                        {show4 && <Terms bgCover="valor--modal" header="TEAM LEAGUE" onClose={close} imagelogo={valor}/>}
                        {showAct && <Activation bgCover="valor--bg" onClose={close} imageLogo={valor}/>}
                </div>
            </div>
        </>
    )
}

export default ValorPage
